// The padding between the the label and the axis line
export const TICK_PADDING = 15;

// The space from the edge of the graph to the inner/top edge of the axis title
export const TITLE_PADDING = 65;

// The space from the edge of the graph to the edge of the label when there is
// not an axis title
export const MARGIN_PADDING = 15;

// The maximum percentage of the chart's area that can be taken up by the
// margins for displaying labels
export const MAX_MARGIN_PCT = 0.25;

// The line height of the labels
export const LINE_HEIGHT = 1.3333;

// The font size of the labels
export const LABEL_FONT_SIZE = 12;
